<script setup lang="ts">
import { useAxureCloudConfig } from "ls/state/useAxureCloudConfig";
import { AvatarImage } from "reka-ui";
import { computed } from "vue";
import NodeIconImage from "./NodeIconImage.vue";
import { toImageCdnUrl } from "./utils";

const props = defineProps<{
  shortcut: string;
  imageHash: string;
  withoutBackground?: boolean;
}>();

const config = useAxureCloudConfig();

const iconUrl = computed(() => {
  if (config.value) {
    return toImageCdnUrl(props.shortcut, props.imageHash, config.value, { type: "icon" });
  }
  return undefined;
});
</script>

<template>
  <AvatarImage
    v-if="iconUrl"
    as-child
    :src="iconUrl"
  >
    <NodeIconImage
      :src="iconUrl"
      :without-background="withoutBackground"
    />
  </AvatarImage>
</template>
